import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    textSection: {
        maxWidth: '80%',
        margin: '40px 0 30px 0'
    },
    text: {
        fontSize: 33,
        lineHeight: '1.2em'
    },
    adoptionQuestionnaire: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    adoptionQuestionnaireHeader: {
        width: '100%',
        height: '40px',
        lineHeight: '40px',
        paddingLeft: 5,
        textAlign: 'left',
        color: theme.palette.secondary.dark,
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: theme.palette.primary.light,
        display: 'flex',
        justifyContent: 'space-between',
    },
    adoptionQuestionnaireBody: {
        padding: theme.spacing(2),
        textAlign: 'left'
    },
    adoptionQuestionaireQuestionSet: {
        marginBottom: theme.spacing(2)
    },
    adoptionQuestionnaireQuestion: {
        fontSize: 20,
        fontWeight: 'bold',
    }
}));

export default useStyles;